import Component from '../../../classes/Component';
import {updateCitiesByPhoneChange} from "../../../helpers/_utilities";
import {$events} from "../../../helpers/events";
import variables from "../../../variables";
import {handleRequest} from "../../../pages/goods/utils";

const {customEventNames} = variables;
const formId = 'js-landing-feedback';
const phoneInputId = 'js-landing-common-user-phone';
const cityInputId = 'js-landing-common-user-city';

export default function () {

	return new Component({
		name: 'landingFeedback',
		requiredTargets: ['#'+formId, '#'+phoneInputId, '#'+cityInputId],
		onInit() {
            this.handlePhoneCountryChange = () => updateCitiesByPhoneChange('#'+phoneInputId, cityInputId);

            this.handleFormSubmit = ({detail}) => handleRequest(detail);

            $events.delegate
                .on(customEventNames.validatedFormSubmit, '#'+formId, this.handleFormSubmit)
                .on('countrychange', '#'+phoneInputId, this.handlePhoneCountryChange)
        },
		onDestroy() {
            $events.delegate
                .off(customEventNames.validatedFormSubmit, '#'+formId, this.handleFormSubmit)
                .off('countrychange', '#'+phoneInputId, this.handlePhoneCountryChange)
        }
	})
}
